import { trimLower } from "./StringManipulation"
import { isEmptyOrBlank } from "./Validation"

// If `items` and a `searchString` are passed,
// the function returns all `items` that contain the `searchString`.
// It looks at all field values provided by the `criteriaSelector`
// and compares them in a case-insensitive way with the `searchString`.
// If the `searchString` is empty or blank, all items are returned.
export function filterItems<T>(
  items: T[],
  searchString: string | undefined,
  criteriaSelector: (item: T) => Array<string | undefined>,
): T[] {
  if (isEmptyOrBlank(searchString)) return items
  const searchTerm = trimLower(searchString!)

  return items.filter(item => {
    for (const criteria of criteriaSelector(item)) {
      if (isEmptyOrBlank(criteria)) continue
      if (trimLower(criteria!).includes(searchTerm)) return true
    }
    return false
  })
}

// Functionality-wise this function is the same as the one above.
// However, instead of taking an entire item list,
// it takes only one `item` at a time.
export function matchItem<T>(
  item: T,
  searchString: string | undefined,
  criteriaSelector: (item: T) => Array<string | undefined>,
): boolean {
  if (isEmptyOrBlank(searchString)) return true
  const searchTerm = trimLower(searchString!)

  for (const criteria of criteriaSelector(item)) {
    if (isEmptyOrBlank(criteria)) continue
    if (trimLower(criteria!).includes(searchTerm)) return true
  }
  return false
}
